import { useTranslation } from 'react-i18next';

import { su, theme } from '@adflow/frontend/ui-theme';

export interface IsArchivedCellProps {
	archived: boolean;
}

export function IsArchivedCell({ archived }: IsArchivedCellProps) {
	const { t } = useTranslation('common');

	return (
		<div
			css={[
				su.textSm,
				{
					display: 'flex',
					alignItems: 'center',
					height: '2rem',
					overflow: 'hidden',
				},
				archived && {
					color: theme.colors.palettes.delete.dark,
				},
			]}
		>
			{archived ? t('yes') : t('no')}
		</div>
	);
}
